module.exports = __webpack_public_path__ + "static/media/dentalemergency.c5d9cb14.png";